var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDefaultFileIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "200px",
    width: "200px",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 512 512",
    xmlSpace: "preserve",
    fill: "#000000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2E7F0"
    },
    d: "M104,0C86.328,0,72,14.328,72,32v448c0,17.672,14.328,32,32,32h304c17.672,0,32-14.328,32-32V128 L312,0H104z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9DACBA"
    },
    d: "M344,128h96L312,0v96C312,113.672,326.328,128,344,128z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9DACBA"
    },
    d: "M192,160h128c4.416,0,8,3.584,8,8l0,0c0,4.416-3.584,8-8,8H192c-4.416,0-8-3.584-8-8l0,0 C184,163.584,187.584,160,192,160z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9DACBA"
    },
    d: "M144,328h224c4.416,0,8,3.584,8,8l0,0c0,4.416-3.584,8-8,8H144c-4.416,0-8-3.584-8-8l0,0 C136,331.584,139.584,328,144,328z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9DACBA"
    },
    d: "M144,424h128c4.416,0,8,3.584,8,8l0,0c0,4.416-3.584,8-8,8H144c-4.416,0-8-3.584-8-8l0,0 C136,427.584,139.584,424,144,424z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9DACBA"
    },
    d: "M144,376h224c4.416,0,8,3.584,8,8l0,0c0,4.416-3.584,8-8,8H144c-4.416,0-8-3.584-8-8l0,0 C136,379.584,139.584,376,144,376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9DACBA"
    },
    d: "M144,280h224c4.416,0,8,3.584,8,8l0,0c0,4.416-3.584,8-8,8H144c-4.416,0-8-3.584-8-8l0,0 C136,283.584,139.584,280,144,280z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#9DACBA"
    },
    d: "M144,232h224c4.416,0,8,3.584,8,8l0,0c0,4.416-3.584,8-8,8H144c-4.416,0-8-3.584-8-8l0,0 C136,235.584,139.584,232,144,232z"
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#C9D5E3"
    },
    d: "M344,128l75.28,75.28c3.024,3.008,4.72,7.096,4.72,11.36V480c0,8.84-7.16,16-16,16H120 c-8.84,0-16,7.16-16,16h304c17.672,0,32-14.328,32-32V128H344z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultFileIcon);
export default __webpack_public_path__ + "static/media/default-file-icon.b12d95820282e372216e13d373887b8a.svg";
export { ForwardRef as ReactComponent };